import { Component } from 'react'
import { connect } from 'react-redux'
import WPAPI from 'wpapi'
import PropTypes from 'prop-types'
import { updateContent } from 'store/content'
import { selectService } from 'store/selectedService'
import { toggleBlockUI } from 'store/blockUI'
import { rootPath } from 'lib/Utils'

class NewsItem extends Component {
  componentDidMount () {
    // this.props.updateContent({ type: 'service', 'title': 'Services' })
    this.doAjaxCall()
  }

  componentDidUpdate () {
    // this.props.updateContent({ type: 'service', 'title': 'Services' })
    this.doAjaxCall()
  }

  doAjaxCall () {
    this.props.toggleBlockUI(true)
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })

    let contentObject = { type: 'service', 'title': 'Services' }

    // Do an ajax requesto to WP API in order to get
    // the posts and the categories
    wp.pages().slug(this.props.params.slug).embed().get()
      .then((data) => {
        this.props.toggleBlockUI(false)
        contentObject.item = data[0]
        this.props.updateContent(contentObject)
        if (selectService !== contentObject.item.id) {
          this.props.selectService(contentObject.item.id)
        }
      })
      .catch((error) => {
        console.warn(error)
        this.props.toggleBlockUI(false)
      })
  }

  render () {
    return null
  }
}

const mapDispatchToProps = {
  updateContent: (content) => updateContent(content),
  selectService: (serviceID) => selectService(serviceID),
  toggleBlockUI: (block) => toggleBlockUI(block)
}

NewsItem.propTypes = {
  params: PropTypes.object,
  updateContent: PropTypes.func,
  selectService: PropTypes.func,
  toggleBlockUI: PropTypes.func
}

export default connect(null, mapDispatchToProps)(NewsItem)



// WEBPACK FOOTER //
// ./src/routes/Service/index.js